{
    "PartitionList_Column_Description": "Beschreibung",
    "PartitionList_Column_IDInTelSys": "AUSWEIS",
    "PartitionList_Column_Licence": "Lizenz",
    "PartitionList_Column_Extensions": "Erweiterungen",
    "PartitionList_Column_AcdAgents": "Agenten",
    "PartitionList_Column_AppUsers": "Benutzer",
    "PartitionList_Column_SyncType": "Synchronisierungstyp",
    "PartitionList_Column_Status": "Status",
    "PartitionList_Filter_Licence": "Lizenz",
    "PartitionList_CountLink_ExtensionsAria": "Geräte in dieser Partition anzeigen",
    "PartitionList_CountLink_AcdAgentsAria": "ACD-Agenten in dieser Partition anzeigen",
    "PartitionList_CountLink_AppUsersAria": "App-Benutzer in dieser Partition anzeigen",
    "PartitionList_Add_Disabled_SelectTelephonyServer": "Wählen Sie einen Telefonieserver aus, dem Sie eine Partition hinzufügen möchten.",
    "NAME": "PartitionListLanguage"
}